export const THIRD_PARTY_DATA_APPS = [
  {
    id: 'cockpit',
    name: 'Cockpit',
    url: 'https://cockpit.globe-groupe.com',
  },
  {
    id: 'gallery',
    name: 'Gallery',
    url: 'https://gallery.globe-groupe.com',
  },
  {
    id: 'gps',
    name: 'GPS',
    url: 'https://gps.globe-groupe.com',
  },
  {
    id: 'weekly',
    name: 'Weekly',
    url: 'https://weekly.globe-groupe.com',
  },
  {
    id: 'globe-data',
    name: 'Globe Data',
    url: 'https://globe-data.omagad.tech/',
  },
  {
    id: 'scan-tickets',
    name: 'Scan Tickets',
    url: 'https://scan.globe-data.tech/',
  },
];

